@let val = processedValue();
@if (val !== '') {
  <span class="font-mono">{{ val }}</span>
  @if (unit()) {
    <span class="text-text-tertiary ml-1 font-mono">{{ unit() }}</span>
  }
}
